import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

const SellPutSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.27196 28.384L8.81377 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M8.81377 18.0225L17.4397 5.44064H31.2328" stroke="#089981" strokeWidth="2"/>
    </svg>
)
const SellPut: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {SellPutSvg(props)}
    </SvgIcon>
));
export default SellPut